<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        @save="$refs.Form.save()"
        hide-header
        persistent
        ref="RkmModal"
    >
        <Form
            :centro-custo="centroCusto"
            :opcao-entrada="opcaoEntrada"
            :prioridades="prioridades"
            @save="handleSave"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    data: () => ({
        centroCusto: null,
        opcaoEntrada: null,
    }),
    methods: {
        open(centroCusto, opcaoEntrada) {
            this.centroCusto = centroCusto
            this.opcaoEntrada = opcaoEntrada
            this.$refs.RkmModal.show()
        },
        handleExit() {
            this.$refs.RkmModal.hide()
        },
        handleSave() {
            this.handleExit()
        },
    },
    props: {
        prioridades: { type: Array, required: true },
    },
}
</script>